const passwordStrengthChecker = (password) => {
  let strength = 0;

  if (password.length >= 8) strength += 1;
  if (/[A-Z]/.test(password)) strength += 1;
  if (/[a-z]/.test(password)) strength += 1;
  if (/[0-9]/.test(password)) strength += 1;
  if (/[\W_]/.test(password)) strength += 1; // Special characters

  if (strength <= 1) return "Weak";
  if (strength === 2) return "Fair";
  if (strength === 3) return "Good";
  if (strength >= 4) return "Strong";

  return "Very Weak";
};

const getPasswordColor = (strength) => {
  if (!strength) return "blue";
  switch (strength.toLowerCase()) {
    case "very weak":
    case "weak":
      return "red";
    case "fair":
      return "orange";
    case "good":
    case "strong":
    case "very strong":
      return "green";
    default:
      return "blue";
  }
};

export { passwordStrengthChecker, getPasswordColor };

